module.exports = __webpack_public_path__ + "static/media/user-default-logo-home.47fef7ff.svg";